import { render } from "./GlucoseMenuView.vue?vue&type=template&id=0e0514c2&scoped=true"
import script from "./GlucoseMenuView.vue?vue&type=script&lang=js"
export * from "./GlucoseMenuView.vue?vue&type=script&lang=js"

import "./GlucoseMenuView.vue?vue&type=style&index=0&id=0e0514c2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0514c2"]])

export default __exports__